import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class OccupationsService extends CrudService {
  constructor(public override http: HttpClient) {
    super('occupations', http);
  }

  /**
   * Check occupations field is unique
   * @returns object
   */
  checkUniqueOccupationFields(occupationFieldName: string, occupationFieldValue: string, id: number) {
    return this.http.get(`${ this.baseUrl }/check-unique-occupation-fields/${ occupationFieldName }/${ occupationFieldValue }/${ id }`);
  }
}
